import {
  isSupportedCountry,
  isValidPhoneNumber as libraryIsValidPhoneNumber,
  parsePhoneNumberFromString,
  type CountryCode,
} from 'libphonenumber-js/max';
import { environment } from '@/config/environment';

function resolveDefaultPhoneCountry(): CountryCode {
  const candidateCountry = environment.defaultPhoneCountry.toUpperCase();
  return isSupportedCountry(candidateCountry) ? candidateCountry : 'PL';
}

export const DEFAULT_PHONE_COUNTRY: CountryCode = resolveDefaultPhoneCountry();

export function isValidPhoneNumber(value: string): boolean {
  if (value.trim().length === 0) {
    return false;
  }
  return libraryIsValidPhoneNumber(value);
}

export function isBlankOrValidPhoneNumber(value: string): boolean {
  return value.trim().length === 0 || isValidPhoneNumber(value);
}

export function formatPhoneNumberForDisplay(value: string | null): string {
  if (value === null || value.trim().length === 0) {
    return '';
  }
  const parsedNumber = parsePhoneNumberFromString(value);
  if (parsedNumber === undefined) {
    return value;
  }
  return parsedNumber.formatInternational();
}
